export default __webpack_public_path__ + "static/dear-system-hero-img-e9cfee16e8a4cbe110e06a94cb73dbe3.png";